import {
  ExpandMoreOutlined,
  KeyboardBackspaceOutlined,
  EditOutlined,
  DeleteOutline,
  AddCircleOutlineOutlined,
} from "@mui/icons-material";
import {
  Typography,
  Button,
  Grid,
  Card,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardContent,
  Divider,
} from "@mui/material";
import { MatxLoading } from "app/components";

import {
  deleteResearchProject,
  getUserResearchProject,
} from "app/services/researchProjectServices/ResearchProject";
import React, { useEffect, useState } from "react";
import FormProject from "./FormProject";
import { formatDate } from "app/services/dateTimeServices/format";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";

export type Project = UserProject[];

export interface UserProject {
  id: number;
  user_id: number;
  research_project_id: number;
  active: number;
  created_at: string;
  updated_at: any;
  research_project: ResearchProject;
}

export interface ResearchProject {
  id: number;
  title: string;
  author: string;
  proccess: string;
  financier: string;
  type: string;
  division_id: number;
  status: string;
  initial_date: string;
  end_date: string;
  summary: string;
  created_by: number;
  created_at: string;
  updated_at: string;
}

const ProjectInfo = ({ project, setEditProject, deleteProject, deleting }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreOutlined />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" display="block">
            {project.proccess} - {project.title}
          </Typography>
          <Typography variant="subtitle2" color="textSecondary" display="block">
            Vigência: {formatDate(project.initial_date)} à{" "}
            {formatDate(project.end_date)}
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Autor:
            </Typography>
            <Typography variant="body1">{project.author}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Processo:
            </Typography>
            <Typography variant="body1">{project.proccess}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Finaciador:
            </Typography>
            <Typography variant="body1">{project.financier}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Tipo:
            </Typography>
            <Typography variant="body1">{project.type}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Cidade:
            </Typography>
            <Typography variant="body1">{project.division_id}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Status:
            </Typography>
            <Typography variant="body1">{project.status}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Data de Inicio:
            </Typography>
            <Typography variant="body1">
              {formatDate(project.initial_date)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Data Final:
            </Typography>
            <Typography variant="body1">
              {formatDate(project.end_date)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">
              Resumo:
            </Typography>
            <Typography variant="body1">{project.summary}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Criado por:
            </Typography>
            <Typography variant="body1">{project.user.name}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Criado Em:
            </Typography>
            <Typography variant="body1">
              {formatDate(project.created_at)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => setEditProject(project)}
            >
              <EditOutlined /> &nbsp; Editar Projeto
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} style={{ textAlign: "right" }}>
            <LoadingButton
              loading={deleting}
              variant="contained"
              size="small"
              color="error"
              onClick={() => deleteProject(project.id)}
            >
              <DeleteOutline /> &nbsp; Excluir Projeto
            </LoadingButton>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

const ListProject = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [projectData, setProjectData] = useState<UserProject[]>([]);
  const [newProject, setNewProject] = useState<boolean>(false);
  const [editProject, setEditProject] = useState<any>();
  const [deleting, setDeleting] = useState<boolean>(false);

  const loadResearchProjectList = async () => {
    const request: any = await getUserResearchProject();
    const data = request.data.response;
    setProjectData(data);
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    loadResearchProjectList();
  }, [editProject, newProject]);

  const deleteProject = async (id: number) => {
    setDeleting(true);
    Swal.fire({
      title: `Deseja excluir o projeto de pesquisa selecionado?`,
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "Cancelar e manter",
      confirmButtonText: "Excluir",
      confirmButtonColor: "red",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const deleteRequest = await deleteResearchProject(id); // eslint-disable-line
        } catch (e: any) {
          Swal.showValidationMessage(`${e.response.data.response}`);
        } finally {
          setDeleting(false);
          loadResearchProjectList();
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Projeto Excluído com Sucesso",
          icon: "success",
        });
      }
      setDeleting(false);
    });
  };

  if (loading) {
    return (
      <div style={{ height: "10vh" }}>
        <MatxLoading />
      </div>
    );
  }

  if (!newProject && !editProject) {
    return (
      <Card>
        <CardContent>
          <Grid container>
            <Grid
              item
              xs={12}
              container
              justifyContent="space-between"
              alignItems="center"
              paddingLeft={1}
              paddingTop={1}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  marginBottom: 1,
                  fontWeight: 600,
                  color: "#1a237e",
                  letterSpacing: "-0.5px",
                }}
              >
                Cadastro de Projeto de Pesquisa
                <Typography
                  variant="body1"
                  sx={{ marginBottom: 3, color: "#000" }}
                >
                  Cadastre todos os projetos de pesquisa que tem participação.
                </Typography>
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => setNewProject(true)}
                startIcon={<AddCircleOutlineOutlined fontSize="small" />}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  px: 2,
                  py: 1,
                  boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(25, 118, 210, 0.3)",
                  },
                }}
              >
                Cadastrar Projeto
              </Button>
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              {projectData.map((project) => (
                <ProjectInfo
                  key={project.id}
                  project={project.research_project}
                  setEditProject={setEditProject}
                  deleteProject={deleteProject}
                  deleting={deleting}
                />
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  if (newProject) {
    return (
      <Card>
        <CardContent>
          <Grid container>
            <Grid
              item
              xs={12}
              container
              justifyContent="space-between"
              alignItems="center"
              paddingLeft={1}
              paddingTop={1}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  marginBottom: 1,
                  fontWeight: 600,
                  color: "#1a237e",
                  letterSpacing: "-0.5px",
                }}
              >
                Cadastrar novo Projeto
                <Typography
                  variant="body1"
                  sx={{ marginBottom: 3, color: "#000" }}
                >
                  Preencha todas as informações necessárias.
                </Typography>
              </Typography>
              <Button
                variant="text"
                color="primary"
                size="small"
                onClick={() => setNewProject(false)}
              >
                <KeyboardBackspaceOutlined />
                &nbsp; Voltar
              </Button>
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <FormProject setNewProject={setNewProject} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  if (editProject) {
    return (
      <Card>
        <CardContent>
          <Grid container>
            <Grid
              item
              xs={12}
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h5">Editar Projeto de Pesquisa</Typography>
              <Button
                variant="text"
                color="primary"
                size="small"
                onClick={() => setEditProject(null)}
              >
                <KeyboardBackspaceOutlined />
                &nbsp; Voltar
              </Button>
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <FormProject data={editProject} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  return (
    <div style={{ height: "10vh", textAlign: "center" }}>
      <Typography variant="h6"> Falha ao Renderizar a página </Typography>
    </div>
  );
};

export default ListProject;
